var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeLowSpeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 30,
    viewBox: "0 0 96 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.125,
    width: 94.5,
    height: 27.75,
    rx: 13.875,
    stroke: "#FC5955",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1304 12.8441L13.5625 16.375H17.6875V21.1875L20.5244 17.2868M17.3125 11.2188L19.0625 8.8125V12.25M21.6875 15.6875L23.1875 13.625H20.4375",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 8.8125L24.5625 21.1875",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1817 14.5835H45.7917V15.2975H37.1817V14.5835ZM41.0352 13.145H41.8962V14.909H41.0352V13.145ZM41.0247 9.974H41.7807V10.394C41.7807 12.1055 39.9642 13.3235 38.0322 13.6385L37.6962 12.9455C39.3972 12.7145 41.0247 11.6645 41.0247 10.394V9.974ZM41.1612 9.974H41.9067V10.394C41.9067 11.6645 43.5447 12.7145 45.2352 12.9455L44.9097 13.6385C42.9882 13.313 41.1612 12.1055 41.1612 10.394V9.974ZM38.1372 16.2215H44.6997V19.319H43.8282V16.925H38.1372V16.2215ZM47.9329 14.258H54.4534V14.972H47.9329V14.258ZM46.8514 17.3975H55.4509V18.1325H46.8514V17.3975ZM50.6944 14.5625H51.5659V17.6915H50.6944V14.5625ZM47.9329 10.583H54.3589V11.297H48.8044V14.573H47.9329V10.583ZM59.8249 10.751H64.1929V16.9355H59.8249V10.751ZM63.3424 11.4545H60.6754V16.232H63.3424V11.4545ZM66.1774 9.8165H67.0489V19.3295H66.1774V9.8165ZM69.3686 13.544H70.1036C72.0146 13.544 73.1381 13.481 74.4401 13.2185L74.5451 13.922C73.2011 14.195 72.0461 14.258 70.1036 14.258H69.3686V13.544ZM69.3686 10.373H73.5581V11.0765H70.2296V13.964H69.3686V10.373ZM75.4376 9.827H76.3091V14.6045H75.4376V9.827ZM76.0676 11.822H77.7161V12.5465H76.0676V11.822ZM70.2821 15.0875H76.3091V17.429H71.1641V18.899H70.3031V16.757H75.4586V15.7805H70.2821V15.0875ZM70.3031 18.4895H76.6556V19.193H70.3031V18.4895Z",
    fill: "#FC5955"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeLowSpeed);
export default __webpack_public_path__ + "static/media/badge_low_speed.e6c2c406f6a14ec4c497f5a0c24766f4.svg";
export { ForwardRef as ReactComponent };